import { Tooltip as TooltipBase, TooltipContent, TooltipTrigger } from '@radix-ui/react-tooltip';
import classNames from 'classnames';
import * as React from 'react';

export type Side = 'top' | 'bottom' | 'left' | 'right';

interface TooltipProps {
  children: React.ReactNode;
  content: React.ReactNode | null;
  hidden?: boolean;
  side?: Side;
  className?: string;
  marginAuto?: boolean;
}

export const Tooltip = ({ children, content, hidden = false, side = 'bottom', className, marginAuto = true }: TooltipProps) => {
  if (hidden || !content || !children) {
    return null;
  }
  return (
    <TooltipBase>
      <TooltipTrigger className={classNames('flex', !content && 'hover:cursor-default', className, marginAuto && 'm-auto')}>{children}</TooltipTrigger>
      {content && (
        <TooltipContent
          side={side}
          className={
            'z-50 overflow-hidden rounded-md bg-slate-900 m-2 px-3 py-1.5 text-xs text-slate-50 animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 flex flex-col text-center gap-1'
          }
        >
          {content}
        </TooltipContent>
      )}
    </TooltipBase>
  );
};
